import DnsConfigSection from './components/DnsConfigSection';

/**
 * Top-level controller for the Organization Settings tab.
 * Visible only to owner-ish users (enforced by user-settings-controller).
 */
const OrgSettingsController = () => (
  <div style={{ maxWidth: '700px' }}>
    <h2>Organization Settings</h2>
    <DnsConfigSection />
  </div>
);

export default OrgSettingsController;
